import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import FormGroup from '@/components/core/form/FormGroup.vue'
import LInput from '@/components/core/form/Input.vue'
import LButton from '@/components/core/Button.vue'
import { useCreateShareToken } from '@/composables/share-token'
import {
  PrivacySetting,
  privacySettings as allPrivacySettings,
} from '@/types/trip'
import { logEvent } from '@/utils/utility-manager'

export interface ShareTokenCardProps {
  tripId: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewShareTokenCard',
  props: {
    tripId: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tripId: string
};





const name = ref('')

const defaultPrivacySettings = allPrivacySettings.reduce(
  (acc, setting) => {
    acc[setting] = ['pois', 'activities', 'photos'].includes(setting)
    return acc
  },
  {} as Record<PrivacySetting, boolean>,
)

const privacySettings = ref(defaultPrivacySettings)

const { isLoading, mutateAsync: createShareToken } = useCreateShareToken(
  props.tripId,
)

async function handleSave() {
  const checkedPrivacySettings = Object.entries(privacySettings.value)
    .filter(([, isChecked]) => isChecked)
    .map(([setting]) => setting as PrivacySetting)

  logEvent('trip_share_token_created', {
    privacySettingsCount: checkedPrivacySettings.length,
  })

  await createShareToken({
    name: name.value,
    privacySettings: checkedPrivacySettings,
  })

  emit('close')
}

function handleCancel() {
  logEvent('trip_share_token_creation_cancelled')

  // Reset to original settings
  privacySettings.value = defaultPrivacySettings

  emit('close')
}

function handlePrivacyToggle(setting: PrivacySetting, value: boolean) {
  logEvent('trip_share_new_token_privacy_setting_toggled', {
    setting,
    enabled: value,
  })
}

return { __sfc: true,props, emit, name, defaultPrivacySettings, privacySettings, isLoading, createShareToken, handleSave, handleCancel, handlePrivacyToggle, FormGroup, LInput, LButton, allPrivacySettings }
}

})